import React from 'react';
import { IsLockedIndicator } from 'Feature/V2/HbtMasterPool/components/HbtMasterPoolDetails/utils/masterPoolConstants';
import { LockAndUnlockFooter } from '../../components/LockAndUnlockFooter';
import { TFunction } from 'i18next';
import { RiskResult, ScenarioData } from '../../types';
import { MRT_ColumnDef } from 'material-react-table';

interface Props {
  data: RiskResult[];
  t: TFunction;
  language: string;
  showFooter: boolean;
  renderFirstColumn: (props: any) => JSX.Element;
  handleFooterScenarioClick: (risk: any) => void;
  headerColumn: MRT_ColumnDef<ScenarioData>;
  sizeColumn: (scenarioNumber: number, language: string) => number;
  isMasterpoolInLockedStatus?: boolean;
}
export const LegacyPoolScenarioColumns = ({
  data,
  t,
  language,
  showFooter,
  renderFirstColumn,
  handleFooterScenarioClick,
  headerColumn,
  sizeColumn,
  isMasterpoolInLockedStatus = false
}: Props): MRT_ColumnDef<ScenarioData>[] => {
  const acceptedScenariosNumber = [1, 2, 3];

  const hasAnyLocked = data.some((r) => r.lockIndicator === IsLockedIndicator.IsLockedIndicator);

  const final = data
    .filter((risk) => acceptedScenariosNumber.includes(risk.scenarioNumber))
    .map((risk) => ({
      accessorKey: `scenario${risk.scenarioNumber}` as const,
      header: t(`Scenario${risk.scenarioNumber}`),
      Cell: renderFirstColumn,
      size: sizeColumn(risk.scenarioNumber, language),
      scenarioNumber: risk.scenarioNumber,
      lockIndicator: risk.lockIndicator,
      muiTableHeadCellProps:
        risk.lockIndicator === IsLockedIndicator.IsLockedIndicator && isMasterpoolInLockedStatus
          ? {
              sx: {
                borderBottom: '4px solid #00093A'
              }
            }
          : undefined,
      Footer: () => {
        if (showFooter && risk.lockIndicator === IsLockedIndicator.IsLockedIndicator) {
          return (
            <LockAndUnlockFooter
              isUnlock={hasAnyLocked}
              risk={risk}
              onClick={handleFooterScenarioClick}
              t={t}
            />
          );
        } else if (showFooter && !hasAnyLocked) {
          return (
            <LockAndUnlockFooter
              isUnlock={hasAnyLocked}
              risk={risk}
              onClick={handleFooterScenarioClick}
              t={t}
            />
          );
        } else {
          return undefined;
        }
      }
    }));

  return [headerColumn, ...final.sort((a, b) => a.scenarioNumber - b.scenarioNumber)];
};
